export default __webpack_public_path__ + "static/media/muove.f1af32e2.svg";